<template>
  <section>
    <div class="wrap">
      <div class="section-head">
        <div class="left">
          <span class="eyebrow"><span class="dot"></span>{{ labelsState['lv_steps_eyebrow'] || 'How it works' }}</span>
          <h2>{{ labelsState['lv_steps_heading_pre'] || 'From idea to production assistant' }} <span class="grad-text">{{ labelsState['lv_steps_heading_grad'] || 'in an afternoon.' }}</span></h2>
        </div>
        <div class="right">
          {{ labelsState['lv_steps_desc'] || 'No code, no external integrators. Three guided steps and your team responding through AI today.' }}
        </div>
      </div>
      <div class="steps">
        <article class="step">
          <span class="step-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22">
              <path d="M9.5 2a3 3 0 00-3 3 3 3 0 00-3 3v2a3 3 0 001.5 2.6A3 3 0 003 15v2a3 3 0 003 3 3 3 0 003 3 3 3 0 003-3V5a3 3 0 00-3-3zM14.5 2a3 3 0 013 3 3 3 0 013 3v2a3 3 0 01-1.5 2.6A3 3 0 0121 15v2a3 3 0 01-3 3 3 3 0 01-3 3 3 3 0 01-3-3V5a3 3 0 013-3z"/>
            </svg>
          </span>
          <h3>{{ labelsState['lv_step_connect_title'] || 'Connect your sources' }}</h3>
          <p>{{ labelsState['lv_step_connect_body'] || 'Upload documents, FAQs, catalogs or connect your CRM/Shopify/HubSpot. NQA indexes everything automatically.' }}</p>
        </article>
        <article class="step">
          <span class="step-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22">
              <rect x="3" y="8" width="18" height="12" rx="3"/>
              <path d="M12 4v4M9 13h.01M15 13h.01M9 17h6"/>
              <circle cx="12" cy="3" r="1"/>
            </svg>
          </span>
          <h3>{{ labelsState['lv_step_configure_title'] || 'Design the personality' }}</h3>
          <p>{{ labelsState['lv_step_configure_body'] || 'Tone, language, business rules, what it can promise and what to escalate. Configure it in plain language.' }}</p>
        </article>
        <article class="step">
          <span class="step-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="22" height="22">
              <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"/>
            </svg>
          </span>
          <h3>{{ labelsState['lv_step_publish_title'] || 'Publish and measure' }}</h3>
          <p>{{ labelsState['lv_step_publish_body'] || 'Activate channels with one click. Live dashboard with conversions, satisfaction and hot topics.' }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

export default {
  name: 'StepsV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return { labelsState: computed(() => labelsStore.labels) };
  },
};
</script>
